import {useQuery} from '@tanstack/react-query'
import {getChannelDetails} from '../services/chat.http'
import {ChannelID} from '@/features/chat/types.ts'
import {useGetRepresentedUser} from '@/hooks/useGetRepresentedHost'
import {useHandleError} from '@/hooks/useHandleError'
import {QUERY_KEYS} from './keys'
import {Channel} from '../chat.model'

export const useGetChannelDetailsV3 = (channelID: ChannelID, enabled = true) => {
    const {representedUserId} = useGetRepresentedUser()
    const isGroupOrBroadcast = channelID?.includes?.('group') || channelID?.includes?.('broadcast')

    const query = useQuery({
        queryKey: [QUERY_KEYS.fetchChannelDetailsV3, channelID, representedUserId],
        queryFn: () => getChannelDetails(channelID, {representedCreatorId: representedUserId}),
        enabled: !!channelID && enabled && !isGroupOrBroadcast
    })

    useHandleError({isError: query?.isError, error: query?.error, isBlankPage: true})

    return {...query, data: {...query.data, pk: channelID as string} as Channel}
}
